import { fetchGetSplitTest } from '@iwoca/lapi-client/edge';
import { fetchLendingAPIJSON } from '@iwoca/lapi-client/lendingAPI';

import { lendingApiFetchWithoutContentType } from './lendingApiQueries';
import { TGetLegalFormDE } from '../lapiOverrideTypesDE';
import { TIsolatedSplitTests } from '../types';

export const fetchGetLegalForm = (
  crefoId: string,
): Promise<TGetLegalFormDE> => {
  return fetchLendingAPIJSON(
    `/api/lending/edge/legal_form/?crefo_id=${crefoId}`,
  );
};

export async function fetchQualifiedLeadType() {
  const response = await lendingApiFetchWithoutContentType(
    `/api/paid_search/get_qualified_lead_type/`,
  );
  return await response.json();
}

export async function fetchGetSplitTestStrict(
  stateKey: string,
  experimentName: TIsolatedSplitTests,
) {
  return await fetchGetSplitTest({
    stateKey,
    experimentName,
  });
}
